module.exports = __webpack_public_path__ + "82ae2b11825d739985ff3ac1f2f73b4e.png";